import { goRequest } from '../utils/httpClientTs';
import {
  FinanceElfLoansListParams,
  FinanceElfLoansListResponse,
} from '../types/financeElfLoans';

export const getFinanceElfLoansList = async (
  params: FinanceElfLoansListParams
): Promise<FinanceElfLoansListResponse> => {
  let url = `/finance/elf-loans?page_size=${params.page_size}&page=${params.page}`;

  if (params.search) {
    url += `&search=${encodeURIComponent(params.search)}`;
  }
  if (params.order_by) {
    url += `&order_by=${encodeURIComponent(params.order_by)}`;
  }
  if (params.order) {
    url += `&order=${encodeURIComponent(params.order)}`;
  }

  return goRequest<FinanceElfLoansListResponse>({
    url: url,
    method: 'GET',
  });
};
